import { jsx } from "panel";
import { ModalEl, ModalType } from "common/components/modal";
import { ProfileSidebarEl } from "common/widgets/profile-sidebar";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { truncate } from "common/util/string";
import { pluralize } from "common/query-builder/cohorts-query-builder/util";
import { SidebarUserListEl } from "./sidebar-user-list";
import { TabOptions } from "./types";
export function template() {
  var _a;
  return /* @__PURE__ */ jsx("div", {
    sel: ".user-sidebar"
  }, /* @__PURE__ */ jsx(ModalEl, {
    attrs: {
      "modal-type": ModalType.RightDrawer,
      open: true,
      closeable: true,
      "hide-close-button": true,
      "hide-backdrop": true
    }
  }, /* @__PURE__ */ jsx(SidebarUserListEl, {
    style: {
      display: this.state.selectedTab === TabOptions.USER_LIST ? `block` : `none`
    },
    attrs: {
      color: this.attr(`color`),
      segments: this.attr(`segments`),
      "report-name": this.attr(`report-name`),
      "data-group-name": this.attr(`data-group-name`),
      "segment-label": this.attr(`segment-label`),
      "include-all-users": this.attr(`include-all-users`),
      "hide-cohort-functionality": this.attr(`hide-cohort-functionality`)
    },
    props: {
      cohort: this.state.cohort,
      cohortDetails: this.state.cohortDetails
    },
    on: {
      userSelected: this.handleUserSelected,
      close: this.handleClose
    }
  }, !this.attr(`hide-cohort-functionality`) && /* @__PURE__ */ jsx(ButtonEl, {
    slot: "header-actions",
    sel: ".open-in-new-page",
    attrs: {
      icon: `expand`,
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Small,
      href: this.getUsersPageUrl(),
      target: `_blank`
    },
    on: {
      click: () => this.trackExpandUsersPage()
    }
  }, "Expand"), /* @__PURE__ */ jsx(ButtonEl, {
    slot: "header-actions",
    sel: ".close",
    attrs: {
      theme: ButtonTheme.Tertiary,
      icon: `x`
    },
    on: {
      click: this.handleClose
    }
  })), this.state.selectedTab === TabOptions.USER_DETAIL && /* @__PURE__ */ jsx(ProfileSidebarEl, {
    attrs: {
      ...this.attr(`from-date`) && this.attr(`to-date`) ? {
        "from-date": this.attr(`from-date`),
        "to-date": this.attr(`to-date`)
      } : {},
      ...this.state.cohort.dataGroupId ? {
        "data-group-id": this.state.cohort.dataGroupId
      } : {},
      "distinct-id": this.state.distinctID
    },
    on: {
      tabChange: this.handleTabChange
    }
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".go-back-button",
    attrs: {
      icon: `arrow-left`,
      theme: ButtonTheme.Tertiary,
      tooltip: ((_a = this.attr(`data-group-name`)) == null ? void 0 : _a.length) > 25 ? {
        text: `View ${pluralize(this.attr(`data-group-name`), true)}`
      } : null
    },
    on: {
      click: this.handleBack
    }
  }, "View ", truncate(pluralize(this.attr(`data-group-name`), true), 25)), /* @__PURE__ */ jsx(ButtonEl, {
    slot: "header-actions",
    sel: ".open-in-new-page",
    attrs: {
      icon: `expand`,
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Small,
      href: this.getUserProfilePageUrl(),
      target: `_blank`
    },
    on: {
      click: () => this.trackExpandProfilePage()
    }
  }, "Expand"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".close",
    attrs: {
      icon: `x`,
      theme: ButtonTheme.Tertiary
    },
    on: {
      click: this.handleClose
    }
  }))));
}
